// Shows lower main-product prices while a product-info upsell is checked.
// Display only: the real price must come from a matching Shopify discount.
(function () {
  if (window.upsellCheckedPricesLoaded) return;
  window.upsellCheckedPricesLoaded = true;

  const PRICE_PLACEHOLDERS = ['price', 'compare_price', 'amount_saved', 'amount_saved_rounded', 'price_each', 'compare_price_each'];

  function parseCheckedPrices(value) {
    const prices = {};
    value.split(',').forEach((pair) => {
      const [quantity, price] = pair.split(':');
      const qty = parseInt(quantity, 10);
      const amount = parseFloat(price);
      if (qty > 0 && !isNaN(amount)) prices[qty] = Math.round(amount * 100);
    });
    return prices;
  }

  function formatMoney(cents, format, withoutTrailingZeros) {
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholder);
    if (!match) return format;

    const formatWithDelimiters = (precision, thousands, decimal) => {
      const parts = (cents / 100).toFixed(precision).split('.');
      const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    };

    let amount;
    switch (match[1]) {
      case 'amount_no_decimals': amount = formatWithDelimiters(0, ',', '.'); break;
      case 'amount_with_comma_separator': amount = formatWithDelimiters(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': amount = formatWithDelimiters(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': amount = formatWithDelimiters(2, "'", '.'); break;
      case 'amount_with_space_separator': amount = formatWithDelimiters(2, ' ', ','); break;
      default: amount = formatWithDelimiters(2, ',', '.');
    }
    if (withoutTrailingZeros) amount = amount.replace(/[.,]00$/, '');
    return format.replace(placeholder, amount);
  }

  // Mirrors snippets/text-with-price.liquid
  function renderTextWithPrice(text, values, format) {
    text = text.split('[quantity]').join(values.quantity);
    for (const key of PRICE_PLACEHOLDERS) {
      const token = `[${key}]`;
      if (!text.includes(token)) continue;
      const parts = text.split(token);
      return `${parts[0]}<span>${formatMoney(values[key], format, true)}</span>${parts[parts.length - 1]}`;
    }
    return text;
  }

  function hasPricePlaceholder(text) {
    return PRICE_PLACEHOLDERS.some((key) => text.includes(`[${key}]`));
  }

  // Swaps markup while remembering the theme's own markup, so unchecking restores it.
  // If the theme re-renders an element while checked, its new markup becomes the original.
  function swap(el, html) {
    if (el.dataset.upsellApplied === el.innerHTML && el.dataset.upsellSource === html) return;
    if (el.dataset.upsellApplied !== el.innerHTML) el.dataset.upsellOriginal = el.innerHTML;
    el.innerHTML = html;
    el.dataset.upsellSource = html;
    el.dataset.upsellApplied = el.innerHTML;
  }

  function restore(el) {
    if (el.dataset.upsellApplied === undefined) return;
    if (el.innerHTML === el.dataset.upsellApplied) el.innerHTML = el.dataset.upsellOriginal;
    delete el.dataset.upsellApplied;
    delete el.dataset.upsellOriginal;
    delete el.dataset.upsellSource;
  }

  // The theme's markup for an element, even while it's swapped
  function originalHTML(el) {
    return el.dataset.upsellApplied === el.innerHTML ? el.dataset.upsellOriginal : el.innerHTML;
  }

  function originalText(el) {
    const tmp = document.createElement('div');
    tmp.innerHTML = originalHTML(el);
    return tmp.textContent;
  }

  function parseMoney(text) {
    const match = text.match(/\d[\d,]*(\.\d+)?/);
    return match ? Math.round(parseFloat(match[0].replace(/,/g, '')) * 100) : NaN;
  }

  function initUpsell(upsell) {
    const section = upsell.closest('.shopify-section') || document;
    const checkedPrices = parseCheckedPrices(upsell.dataset.checkedPrices);
    const moneyFormat = upsell.dataset.mainMoneyFormat;
    const badgeText = upsell.dataset.mainBadgeText || '';
    const variantsJson = document.querySelector(`[data-upsell-main-variants="${upsell.dataset.blockId}"]`);
    const variants = variantsJson ? JSON.parse(variantsJson.textContent) : {};

    const getVariant = () => {
      const idInput = section.querySelector('form[id^="product-form-"] input[name="id"]');
      const id = (idInput && idInput.value) || upsell.dataset.mainVariantId;
      return variants[id] || variants[upsell.dataset.mainVariantId];
    };

    const getValues = (quantity, total, variant) => {
      const compareEach = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
      const compare = compareEach * quantity;
      const saved = Math.max(compare - total, 0);
      return {
        quantity,
        price: total,
        compare_price: compare,
        amount_saved: saved,
        amount_saved_rounded: Math.round(saved / 100) * 100,
        price_each: Math.round(total / quantity),
        compare_price_each: compareEach,
      };
    };

    const updateQuantityBreaks = (checked, variant) => {
      section.querySelectorAll('quantity-breaks .quantity-break[data-quantity]').forEach((label) => {
        const quantity = parseInt(label.dataset.quantity, 10);
        const total = checkedPrices[quantity];
        label.querySelectorAll('[data-text]').forEach((el) => {
          if (!checked || total === undefined || !hasPricePlaceholder(el.dataset.text)) return restore(el);
          swap(el, renderTextWithPrice(el.dataset.text, getValues(quantity, total, variant), moneyFormat));
        });
      });
    };

    // Kaching Bundles app: bars only render final text, so swap the price and
    // add the extra saving to whatever amount the bar's label shows
    // (labels are typed in the app, e.g. "You Save $29.99")
    const updateKachingBars = (checked) => {
      section.querySelectorAll('kaching-bundles-block').forEach((block) => {
        let dealBars = [];
        try {
          dealBars = JSON.parse(block.getAttribute('deal-block')).dealBars || [];
        } catch (e) {}

        block.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id]').forEach((bar) => {
          const dealBar = dealBars.find((item) => item.id === bar.dataset.dealBarId);
          const total = dealBar && checkedPrices[dealBar.quantity];
          const priceEl = bar.querySelector('.kaching-bundles__bar-price');
          const labelEls = bar.querySelectorAll('.kaching-bundles__bar-label');
          if (!priceEl) return;

          if (!checked || total === undefined) {
            [priceEl, ...labelEls].forEach(restore);
            return;
          }

          const price = parseMoney(originalText(priceEl));
          swap(priceEl, formatMoney(total, moneyFormat));
          if (isNaN(price)) return;

          labelEls.forEach((el) => {
            const html = originalHTML(el);
            const saved = parseMoney(originalText(el));
            const oldSaved = formatMoney(saved, moneyFormat);
            if (isNaN(saved) || !html.includes(oldSaved)) return restore(el);
            swap(el, html.split(oldSaved).join(formatMoney(saved + price - total, moneyFormat)));
          });
        });
      });
    };

    const updateMainPrice = (checked, variant) => {
      const price = section.querySelector('.product-page-price .price');
      if (!price) return;

      const quantityBreaks = section.querySelector('quantity-breaks');
      let quantity = 1;
      if (quantityBreaks && quantityBreaks.dataset.updatePrices === 'true') {
        const selected = quantityBreaks.querySelector('input[name="quantity"]:checked');
        quantity = (selected && parseInt(selected.value, 10)) || 1;
      }
      const total = checkedPrices[quantity];

      const priceEls = price.querySelectorAll('.price-item--sale.main-price, .price__regular .main-price');
      const compareEls = price.querySelectorAll('.main-comapre-price');
      const badgeEls = price.querySelectorAll('.price__badge-sale .nowrap');

      if (!checked || total === undefined) {
        [...priceEls, ...compareEls, ...badgeEls].forEach(restore);
        if (price.dataset.upsellAddedSale) {
          price.classList.remove('price--on-sale');
          delete price.dataset.upsellAddedSale;
        }
        return;
      }

      const values = getValues(quantity, total, variant);
      priceEls.forEach((el) => swap(el, formatMoney(total, moneyFormat)));
      compareEls.forEach((el) => swap(el, formatMoney(values.compare_price, moneyFormat)));
      if (values.compare_price > total) {
        const percentage = Math.floor((values.amount_saved * 100) / values.compare_price) + '%';
        const amount = formatMoney(values.amount_saved, moneyFormat, true);
        badgeEls.forEach((el) => swap(el, badgeText.replace('[percentage]', percentage).replace('[amount]', amount)));
        if (!price.classList.contains('price--on-sale')) {
          price.classList.add('price--on-sale');
          price.dataset.upsellAddedSale = 'true';
        }
      }
    };

    let scheduled = false;
    const update = () => {
      if (scheduled) return;
      scheduled = true;
      // Timer, not requestAnimationFrame: rAF is paused in background tabs
      setTimeout(() => {
        scheduled = false;
        const checked = upsell.dataset.selected === 'true';
        updateKachingBars(checked);
        const variant = getVariant();
        if (!variant) return;
        updateQuantityBreaks(checked, variant);
        updateMainPrice(checked, variant);
      });
    };

    new MutationObserver(update).observe(upsell, { attributes: true, attributeFilter: ['data-selected'] });
    // Re-apply after the theme re-renders prices (variant or quantity change)
    new MutationObserver(update).observe(section, { childList: true, subtree: true, characterData: true });
    section.addEventListener('change', update);
    update();
  }

  const init = () => document.querySelectorAll('product-info-upsell[data-checked-prices]').forEach(initUpsell);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
